@if (!control) {
  <span class="money">{{ dataContextAmount | money: false : null : dataContextCurrency }}</span>
}
@if (control && pipe) {
  <astral-field-shell
    [control]="displayControl"
    [forId]="inputId"
    [label]="control.caption"
    [helpText]="helpText"
    [errorMessage]="getErrorMessage()"
    [invalid]="!!getErrorMessage()"
    [readonly]="control.isReadonly"
    [disabled]="control.disabled"
    [required]="control.required"
    >
    <div
      class="money-box"
      [class.money-box--readonly]="control.isReadonly"
      [class.money-box--disabled]="control.disabled"
      [class.money-box--focused]="hasFocus"
      >
      <div class="money-box__control-shell" [class.money-box__control-shell--readonly]="control.isReadonly">
        @if (control.isReadonly) {
          <span class="money-box__readonly-icon" aria-hidden="true">
            <i [class]="readonlyIconClass"></i>
          </span>
        }
        <input
          #editBox
          class="money-box__control"
          autocomplete="off"
          [attr.id]="inputId"
          astralFieldAccessibility
          [astralFieldControl]="displayControl"
          [astralFieldHelpText]="helpText"
          [astralFieldInputId]="inputId"
          [astralFieldInvalid]="!!getErrorMessage()"
          [astralFieldRequired]="control.required"
          [type]="hasFocus ? 'number' : 'text'"
          [required]="control.required ? true : null"
          [readonly]="control.isReadonly ? true : null"
          [formControl]="hasFocus ? editControl : displayControl"
          (blur)="onblur()"
          (focus)="onfocus()"
          />
        </div>
      </div>
    </astral-field-shell>
  }
